import * as am4charts from "@amcharts/amcharts4/charts";

import * as am4core from "@amcharts/amcharts4/core";
import React from "react";

import VLComponent from "../views/VLComponent";


class GraphView extends VLComponent {

    constructor() {
        super();
        this.graphRef = React.createRef();
    }

    componentDidUpdate(p, q, r) {
        if (this.props.graph_data != p.graph_data) {
            setTimeout(this.setupChart, 1000);
        }
    }

    componentDidMount() {
        setTimeout(() => {
            if (this.graphRef.current == null) {
                console.error("no html");
                return;
            }
            //console.log("build chart")
            am4core.options.commercialLicense = true;
            let chart = am4core.create(this.graphRef.current, am4charts.XYChart);

            chart.paddingRight = 20;
            chart.colors.list = [am4core.color("#FFFFFF")];


            let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;

            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;

            let series = chart.series.push(new am4charts.LineSeries());
            series.dataFields.dateX = "date";
            series.dataFields.valueY = "value";

            dateAxis.renderer.grid.template.disabled = this.props.hideAxis;
            valueAxis.renderer.grid.template.disabled = this.props.hideAxis;
            dateAxis.renderer.labels.template.disabled = this.props.hideAxis;
            valueAxis.renderer.labels.template.disabled = this.props.hideAxis;

            this.chart = chart;

            this.setupChart();
        }, 1000);
    }

    render() {
        return <div style={{height: "100%", width: "100%"}} ref={this.graphRef}/>;
    }

    setupChart = () => {
        //console.log("update chart");
        let graph_data = this.props.graph_data || [];
        let data = graph_data.map(d => {
            return {date: new Date(d.timestamp * 1000), value: d.level};
        });
        if (this.chart) {
            this.chart.data = data;
        }
    };

}

export default GraphView;
